export default {"src":"/_next/static/media/serial-prompt.e4a6c737.gif","height":500,"width":1189,"blurWidth":0,"blurHeight":0};